<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"
                >Báo cáo doanh thu đặt phòng theo ngày (Theo nhóm nguồn)</span
              >
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div
            v-loading="loading"
            class="-10 mb-20"
            style="height: 400px !important"
          >
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :get-row-style="getRowStyle"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
          <div class="das-form-title-container mt-10 mb-10">
            <div class="das-form-title">
              <span class="main-title">
                Báo cáo doanh thu đặt phòng theo ngày (Theo nguồn)
              </span>
            </div>
          </div>
          <hr />
          <div class="-10" style="height: 400px !important">
            <GridVx
              ref="agGrid"
              :columns="detailColumns"
              :rows="detailRows"
              class="agGrid"
              dom-layout="scroll"
              :get-row-style="getRowStyle"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Mã đặt phòng</li>
            <li>Tên phòng: hiển thị tên phòng</li>
            <li>Số lượng khách: hiển thị số lượng khách trong phòng</li>
            <li>Hạng phòng: hạng phòng của đặt phòng</li>
            <li>Tên khách: Hiển thị tên khách chính của đặt phòng</li>
            <li>Nguồn: Hiển thị nguồn của đặt phòng</li>
            <li>
              Giá niêm yết: Hiển thị giá phòng được niêm yết (Giá thiết kế)
            </li>
            <li>Ngày đến: Ngày khách dự kiến đến, format DDMMYYYY</li>
            <li>Ngày đi: Ngày khách dự kiến đi, format DDMMYYYY</li>
            <li>
              Dịch vụ thêm: Hiển thị dịch vụ mà đặt phòng đã sử dụng thêm (từ
              bảng code)
            </li>
            <li>Ghi chú: hiển thị ghi chú khi đặt phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getListRevenueBookingDaily,
  getListRevenueBookingDailyExcel
} from '@/api/report_service/revenueBookingDailyReport'
import InfoBtn from './components/InfoBtn.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
const mergeObjects = arr => {
  const mergedObj = {}
  for (const obj of arr) {
    for (const [key, value] of Object.entries(obj)) {
      if (!mergedObj[key]) {
        mergedObj[key] = [value]
      } else {
        mergedObj[key].push(value)
      }
    }
  }
  return mergedObj
}

export default {
  components: {
    SingleCalendar,
    SelectWithSearchTable,
    InfoBtn,
    CalendarRange
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        // wrapText: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: []
      },
      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: []
      },
      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          width: 100
        },
        {
          headerName: 'Mô tả',
          field: 'desc'
        }
      ],
      columns: [
        {
          headerName: this.$t('grid.column.sourceGroup'),
          field: 'source_code',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.averagePrice'),
          field: 'average',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          cellRenderer: params => {
            if (params.value !== null && params.value !== undefined) {
              return `<span>${Number(params.value).toLocaleString('en')}</span>`
            }
          }
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.capacityRoom'),
          field: 'performance',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100

          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.allRoom'),
          field: 'total_room',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Doanh thu dự kiến',
          field: 'expected_revenue',
          sortable: false,
          minWidth: 130,
          cellRenderer: params => this.formatMoneyCell(params)
        },
        {
          headerName: 'Doanh thu thực',
          field: 'actual_revenue',
          sortable: false,
          minWidth: 130,
          cellRenderer: params => this.formatMoneyCell(params)
        },
        {
          headerName: 'Hoàn tiền',
          field: 'refund',
          sortable: false,
          minWidth: 110,
          cellRenderer: params => this.formatMoneyCell(params)
        },
        {
          headerName: 'Doanh thu thực ròng',
          field: 'net_revenue',
          sortable: false,
          minWidth: 150,
          cellRenderer: params => this.formatMoneyCell(params)
        }
      ],
      defaultColumns: [
        {
          headerName: 'Ngày',
          field: 'date',
          minWidth: 150,
          // cellClass: "grid-cell-centered",
          sortable: false
        }
      ],
      detailColumns: [
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_code',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.averagePrice'),
          field: 'average',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          cellRenderer: params => {
            if (params.value !== null && params.value !== undefined) {
              return `<span>${Number(params.value).toLocaleString('en')}</span>`
            }
          }
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.capacityRoom'),
          field: 'performance',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100

          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.allRoom'),
          field: 'total_room',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Doanh thu dự kiến',
          field: 'expected_revenue',
          sortable: false,
          minWidth: 130,
          cellRenderer: params => this.formatMoneyCell(params)
        },
        {
          headerName: 'Doanh thu thực',
          field: 'actual_revenue',
          sortable: false,
          minWidth: 130,
          cellRenderer: params => this.formatMoneyCell(params)
        },
        {
          headerName: 'Hoàn tiền',
          field: 'refund',
          sortable: false,
          minWidth: 110,
          cellRenderer: params => this.formatMoneyCell(params)
        },
        {
          headerName: 'Doanh thu thực ròng',
          field: 'net_revenue',
          sortable: false,
          minWidth: 150,
          cellRenderer: params => this.formatMoneyCell(params)
        }
      ],
      detailRows: [],
      rows: []
    }
  },
  created() {
    this.getListSource()
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    formatMoneyCell(params) {
      if (params.value !== null && params.value !== undefined) {
        return `<span>${Number(params.value).toLocaleString('en')}</span>`
      }
      return ''
    },
    handleCommand(cmmd) {
      if (cmmd == 'excel') {
        getListRevenueBookingDailyExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'doanh_thu_dat_phong_theo_ngay_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val.id
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async attachData() {
      try {
        this.loading = true
        const data = await getListRevenueBookingDaily(this.searchParams)
        this.loading = false

        let rowsTranfer = mergeObjects(data.map.total)
        delete rowsTranfer.date
        // rowsTranfer.entries
        this.rows = []
        data?.map.total.map(it => {
          this.rows.push({
            name: 'Ngày ' + it.date,
            isFullWidthRow: true
          })
          this.rows = [...this.rows, ...it?.source]
          this.rows.push({
            source_code: 'Tổng cộng',
            average: it.average_total,
            performance: it.performance_total,
            total_room: it.total_room_total,
            expected_revenue: it.expected_revenue_total,
            actual_revenue: it.actual_revenue_total,
            refund: it.refund_total,
            net_revenue: it.net_revenue_total,
            rowClass: 'sumRow'
          })
        })

        this.detailRows = []

        data?.map.report.map(it => {
          this.detailRows.push({
            name: 'Ngày ' + it.date,
            isFullWidthRow: true
          })
          this.detailRows = [...this.detailRows, ...it?.source]
          this.detailRows.push({
            source_code: 'Tổng cộng',
            average: it.average_total,
            performance: it.performance_total,
            total_room: it.total_room_total,
            expected_revenue: it.expected_revenue_total,
            actual_revenue: it.actual_revenue_total,
            refund: it.refund_total,
            net_revenue: it.net_revenue_total,
            rowClass: 'sumRow'
          })
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: error?.response?.message ?? 'Đã có lỗi xảy ra'
        })
      } finally {
        this.loading = false
      }
    },
    getRowStyle(params) {
      if (params.data.rowClass) {
        return { background: '#EDF5F1', fontWeight: '600' }
      }
    },

    getRevenueTableRowStyle(params) {
      if (params.data.isTotalRow) {
        return { background: '#EDF5F1', fontWeight: '600' }
      }
    },

    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
